import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/phone.tsx
var Phone = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M10 19H14M8 22H16C17.1046 22 18 21.1046 18 20V4C18 2.89543 17.1046 2 16 2H8C6.89543 2 6 2.89543 6 4V20C6 21.1046 6.89543 22 8 22Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.25 4C5.25 2.48122 6.48122 1.25 8 1.25H16C17.5188 1.25 18.75 2.48122 18.75 4V20C18.75 21.5188 17.5188 22.75 16 22.75H8C6.48122 22.75 5.25 21.5188 5.25 20V4ZM9.25 19C9.25 18.5858 9.58579 18.25 10 18.25H14C14.4142 18.25 14.75 18.5858 14.75 19C14.75 19.4142 14.4142 19.75 14 19.75H10C9.58579 19.75 9.25 19.4142 9.25 19Z",
		fill: "currentColor"
	})
});
//#endregion
export { Phone };
